import {Process} from "./process";

export class TransformUntilMe {
    process: Process;
    input: string;
    inputContentType: string;
    output: string;
    outputContentType: string;
}
